import React from "react";
import { AlertTriangle, ChevronDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const UnpublishedChangesMenu = ({ schedules, selectedIds, onSelectionChange }) => {
  const allSelected = schedules.length > 0 && schedules.every((item) => selectedIds.includes(item.schedule_id));

  const toggleAll = () => {
    onSelectionChange(allSelected ? [] : schedules.map((item) => item.schedule_id));
  };

  const toggleOne = (scheduleId, checked) => {
    onSelectionChange(
      checked
        ? Array.from(new Set([...selectedIds, scheduleId]))
        : selectedIds.filter((id) => id !== scheduleId)
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-8 shrink-0 border-amber-300 bg-amber-50 px-2.5 text-xs text-amber-900 hover:bg-amber-100"
          data-testid="unpublished-changes-menu-button"
        >
          <AlertTriangle className="mr-1.5 h-3.5 w-3.5" />
          {schedules.length} Unpublished Changes
          <ChevronDown className="ml-1.5 h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[min(24rem,calc(100vw-2rem))] p-1.5" data-testid="unpublished-changes-menu">
        <div className="flex items-center justify-between gap-3 px-2 py-1">
          <DropdownMenuLabel className="p-0 text-xs text-slate-500">
            Select draft schedule entries
          </DropdownMenuLabel>
          <button
            type="button"
            className="shrink-0 text-xs font-medium text-indigo-600 hover:text-indigo-800"
            onClick={(event) => { event.preventDefault(); event.stopPropagation(); toggleAll(); }}
            data-testid="unpublished-select-all-button"
          >
            {allSelected ? "Deselect all" : "Select all"}
          </button>
        </div>
        <DropdownMenuSeparator />
        <div className="max-h-72 overflow-y-auto">
          {schedules.length === 0 ? (
            <p className="px-2 py-3 text-sm text-slate-500" data-testid="unpublished-empty-state">No unpublished changes</p>
          ) : schedules.map((schedule) => (
            <DropdownMenuCheckboxItem
              key={schedule.schedule_id}
              checked={selectedIds.includes(schedule.schedule_id)}
              onCheckedChange={(checked) => toggleOne(schedule.schedule_id, checked === true)}
              onSelect={(event) => event.preventDefault()}
              className="items-start py-2"
              data-testid={`unpublished-item-${schedule.schedule_id}`}
            >
              <span className="min-w-0">
                <span className="block truncate text-sm font-medium text-slate-800">{schedule.title}</span>
                <span className="block text-xs text-slate-500">{schedule.date}</span>
              </span>
            </DropdownMenuCheckboxItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};